import React, { useEffect, useState } from 'react';
import axios from 'axios';
//import './PromptButtons.css';
import { Button, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, TextField } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { useSiteSettings } from './context/SiteSettingsContext';
interface ButtonData {
    id: number;
    buttonname: string;
    content: string;
}

interface PromptButtonsProps {
    setPromptCorrection: React.Dispatch<React.SetStateAction<string>>;
    mypromptCorrection: string;
}

const PromptButtons2: React.FC<PromptButtonsProps> = ({ setPromptCorrection, mypromptCorrection}) => {
    const [buttons2, setButtons2] = useState<ButtonData[]>([]);
    const [newButtonName2, setNewButtonName2] = useState('');
    const [isAddDialogOpen2, setIsAddDialogOpen2] = useState(false);
    const { settings: siteSettings, loading: isSiteSettingsLoading } = useSiteSettings();
    const logLevel = siteSettings?.frontend_log_level ?? 0;

    // Buttons aus der API abrufen
    const fetchButtons = async () => {
        try {
            const response = await axios.get('/api/apps/fetch-prompt-buttons2/');
            if (response.status === 200) {
                setButtons2(response.data);
            } else {
                if (!isSiteSettingsLoading && logLevel >= 1) console.error('Fehler beim Abrufen der Buttons:', response.status);
            }
        } catch (error) {
            if (!isSiteSettingsLoading && logLevel >= 1) console.error('API-Fehler beim Abrufen der Buttons:', error);
        }
    };

    // Button hinzufügen
    const addButton2 = async () => {
        if (!newButtonName2.trim()) {
            alert('Bitte einen gültigen Namen eingeben.');
            return;
        }

        try {
            const response = await axios.post('/api/apps/add-prompt-button2/', {
                buttonname: newButtonName2,
                content: mypromptCorrection,
            });
            if (response.status === 201) {
                setButtons2([...buttons2, response.data]);
                setNewButtonName2('');
                setIsAddDialogOpen2(false);
            } else {
                if (!isSiteSettingsLoading && logLevel >= 1) console.error('Fehler beim Hinzufügen des Buttons:', response.status);
            }
        } catch (error) {
            if (!isSiteSettingsLoading && logLevel >= 1) console.error('API-Fehler beim Hinzufügen des Buttons:', error);
        }
    };

    // Button löschen
    const deleteButton2 = async (button_id: number) => {
        if (!window.confirm('Möchten Sie den Button wirklich löschen?')) return;

        try {
            const response = await axios.delete(`/api/apps/delete-prompt-button2/${button_id}/`);
            if (response.status === 200) {
                setButtons2(buttons2.filter((button2) => button2.id !== button_id));
            } else {
                if (!isSiteSettingsLoading && logLevel >= 1) console.error('Fehler beim Löschen des Buttons:', response.status);
            }
        } catch (error) {
            if (!isSiteSettingsLoading && logLevel >= 1) console.error('API-Fehler beim Löschen des Buttons:', error);
        }
    };

    useEffect(() => {
        fetchButtons(); // Initiales Laden der Buttons
    }, []);

    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', overflowX: 'auto', padding: '10px', backgroundColor: '#f9f9f9' }}>
            {buttons2.map((button) => (
                <div
                    key={button.id}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        backgroundColor: '#e3f2fd',
                        padding: '10px',
                        borderRadius: '8px',
                        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
                        width: '200px',
                    }}
                >
                    <Button
                        variant="contained"
                        style={{
                            textTransform: 'none',
                            fontSize: '0.8rem',
                            flexGrow: 1,
                            whiteSpace: 'nowrap', // Text in einer Zeile halten
                            overflow: 'hidden',  // Überlauf ausblenden
                            textOverflow: 'ellipsis', // "..." hinzufügen, wenn Text abgeschnitten wird
                            maxWidth: '170px',  // Maximale Breite des Textes
                        }}
                        onClick={() => setPromptCorrection(button.content)}
                    >
                        {button.buttonname}
                    </Button>
                    <IconButton size="small" color="secondary" onClick={() => deleteButton2(button.id)}>
                        <DeleteIcon />
                    </IconButton>
                </div>
            ))}
            <IconButton
                size="medium"
                color="primary"
                onClick={() => setIsAddDialogOpen2(true)}
                style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    backgroundColor: '#81c784',
                    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
                }}
            >
                <AddIcon />
            </IconButton>
            <Dialog open={isAddDialogOpen2} onClose={() => setIsAddDialogOpen2(false)}>
                <DialogTitle>Neuen Button hinzufügen</DialogTitle>
                <DialogContent>
                    <TextField
                        fullWidth
                        label="Button Name"
                        value={newButtonName2}
                        onChange={(e) => setNewButtonName2(e.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setIsAddDialogOpen2(false)} color="secondary">
                        Abbrechen
                    </Button>
                    <Button onClick={addButton2} color="primary">
                        Hinzufügen
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default PromptButtons2;